<template>
  <div class="container">
    <div class="content-padding">
      <div class="content">
        <img
          class="bg"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_new_member"
          alt=""
          @load="bindLoadImage"
        />
        <div class="rule-btn" @click="jumpRules">活动规则</div>
        <div class="user-content" v-if="info && isLoadImage">
          <img class="avatar" :src="info.head_img" alt="" />
          <div class="user-right">
            <div class="username">
              {{ info.truename | filterName }}
            </div>
            <div class="user-desc" v-if="info.truename">明星减脂营VIP学员</div>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-content" @click="bindReceive">
      <div class="text">免费领取</div>
      <div class="del">原价¥299</div>
    </div>
    <van-overlay :show="showLogin" @click="showLogin = false">
      <LoginComponent
        v-if="showLogin"
        class="login-content"
        @close="bindLoginClose"
        @login="bindLogin"
      />
    </van-overlay>
    <van-loading
      class="v-loading"
      v-if="!loaded"
      text-color="#55417A"
      color="#55417A"
      vertical
      >加载中...</van-loading
    >
  </div>
</template>
<script>
import LoginComponent from './components/login.vue'
export default {
  components: {
    LoginComponent
  },
  data() {
    return {
      errorText: false,
      isFirst: true, //是否是第一次请求
      showLogin: false,
      loaded: false,
      isLoadImage: false,
      info: null
    }
  },
  filters: {
    filterName(name) {
      if (!name) {
        return ''
      }
      if (name.length > 7) {
        name = name.slice(0, 7) + '..'
      }
      return name
    }
  },
  created() {
    this.getData()
  },
  methods: {
    jumpRules() {
      this.$router.push({
        path: '/camp-invite/rules',
        query: {
          type: 0
        }
      })
    },
    bindLoadImage() {
      this.isLoadImage = true
    },
    getData() {
      let params = {
        invitation_id: this.$route.query.inviteId,
        activity_id: this.$route.query.activityId
      }
      this.$http
        .getBaseApp('member/ActivitySys/getInvitationDetail', params)
        .then((res) => {
          res = res.data
          if (res.code === 200) {
            this.info = res.data
          } else {
            this.errorText = res.msg
            this.$toast(res.msg)
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loaded = true
        })
    },
    bindLoginClose() {
      this.showLogin = false
    },
    //登陆领取
    bindLogin(options) {
      let { username, phone, code } = options
      let params = {
        phone: phone,
        invitation_id: this.$route.query.inviteId,
        activity_id: this.$route.query.activityId,
        areaCode: '86',
        identify_code: code,
        truename: username,
        from: '1',
        gender: '0'
      }
      this.$http
        .getBaseApp('member/ActivitySys/receive', params)
        .then((res) => {
          res = res.data
          if (res.code === 200) {
            if (res.data && res.data.data) {
              sessionStorage.setItem('token', res.data.data || '')
              localStorage.setItem('token', res.data.data || '')
            }
            this.showLogin = false
            this.$toast(res.data.msg || '领取成功')
            setTimeout(() => {
              this.$router.push({
                path: '/camp-invite/receive',
                query: {
                  status: res.data.msg
                }
              })
            }, 300)
          } else {
            this.$dialog.alert({
              title: '提示',
              message: res.msg
            })
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    bindReceive() {
      if (this.errorText) {
        this.$toast(this.errorText)
        return
      }
      this.showLogin = true
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  background: linear-gradient(225deg, #ffeded 0%, #efe9ff 100%);
  min-height: 100vh;

  .content-padding {
    box-sizing: border-box;
  }
  .content {
    position: relative;
  }
  .bg {
    width: 100%;
  }
  .user-content {
    position: absolute;
    width: 100%;
    padding: 0px 44px;
    left: 0;
    top: 80px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    .avatar {
      width: 36px;
      height: 36px;
      border-radius: 6px;
      margin-right: 12px;
    }
    .user-right {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
      .username {
        font-size: 15px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #df687d;
        line-height: 22px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .user-desc {
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #55417a;
        line-height: 14px;
      }
    }
  }
  .btn-content {
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    text-align: center;
    height: 48px;
    // IOS底部兼容
    height: calc(48px + 0.5 * constant(safe-area-inset-bottom)); //兼容 IOS<11.2
    height: calc(48px + 0.5 * env(safe-area-inset-bottom)); //兼容 IOS>11.2
    background: #6550a0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .text {
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 22px;
    }
    .del {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(255, 255, 255, 0.5);
      line-height: 17px;
      text-decoration: line-through;
    }
  }
  .login-content {
    position: fixed;
    width: 100%;
    left: 0;
    bottom: 0;
  }
}
.v-loading {
  position: fixed;
  left: 50%;
  top: 30%;
  transform: translate(-50%, 0%);
  z-index: 1;
}
.rule-btn {
  position: fixed;
  right: 0;
  top: 110px;
  width: 32px;
  display: flex;
  text-align: center;
  background: #6f60a2;
  border-radius: 8px 0px 0px 8px;
  padding: 8px;
  box-sizing: border-box;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 15px;
  z-index: 1;
}
</style>
